import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assessment-report-360',
  templateUrl: './assessment-report-360.component.html',
  styleUrls: ['./assessment-report-360.component.scss']
})
export class AssessmentReport360Component implements OnInit {
    //graphic 1
    profileDatasets: any[] = [
        { data: [12.9, 15.0, 12.9, 15.0, 12.9, 14.3, 17.1], label: 'Energetic Profile' }
    ];
    profileLabel: string[] = ['Level 7', 'Level 6', 'Level 5', 'Level 4', 'Level 3', 'Level 2', 'Level 1'];
    profileOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    profileLegend: boolean = true;
    profileChartType: string = 'horizontalBar';


    //graphic 2
    reactionDatasets: any[] = [
        { data: [2.2, 2.5, 4.3, 5.0, 4.3, 24.3, 57.6], label: 'Energetic Stress Reaction' }
    ];
    reactionLabel: string[] = ['Level 7', 'Level 6', 'Level 5', 'Level 4', 'Level 3', 'Level 2', 'Level 1'];
    reactionOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    reactionLegend: boolean = true;
    reactionChartType: string = 'horizontalBar';


    //second tab
    //graphic 1
    graphic1Datasets: any[] = [
        { data: [4, 4, 4, 4.4, 3.5], label: '' }
    ];
    graphic1Label: string[] = ['Self', 'Direct_Report', 'Peer', 'Client', 'Vendor'];
    graphic1Options: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    graphic1Legend: boolean = true;
    graphic1ChartType: string = 'horizontalBar';


    //graphic 2
    graphic2Datasets: any[] = [
        { data: [4, 3.5, 4, 4.4, 2.5], label: '' }
    ];
    graphic2Label: string[] = ['Self', 'Direct_Report', 'Peer', 'Client', 'Vendor'];
    graphic2Options: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    graphic2Legend: boolean = true;
    graphic2ChartType: string = 'horizontalBar';

    //graphic 1
    graphic3Datasets: any[] = [
        { data: [4, 3, 4.5, 4.4, 3.5], label: '' }
    ];
    graphic3Label: string[] = ['Self', 'Direct_Report', 'Peer', 'Client', 'Vendor'];
    graphic3Options: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    graphic3Legend: boolean = true;
    graphic3ChartType: string = 'horizontalBar';


    //graphic 2
    graphic4Datasets: any[] = [
        { data: [3, 3.5, 3.5, 4.6, 3.5], label: '' }
    ];
    graphic4Label: string[] = ['Self', 'Direct_Report', 'Peer', 'Client', 'Vendor'];
    graphic4Options: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    graphic4Legend: boolean = true;
    graphic4ChartType: string = 'horizontalBar';


    //colors
    colors: Array<any> = [
        { // blue
            backgroundColor: '#2d8ac1',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];


    constructor() { }

    ngOnInit() {
    }

}